import { Link } from '@tanstack/react-router'
import { AlertCircle } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import type { OrderingMissing } from '@/api/endpoints/purchase-orders'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { usePermissions } from '@/shared/hooks/use-permissions'
import { ACTIONS } from '@/shared/constants/actions'

/** The Standort cannot send yet: what is missing, and the way to the settings for who may edit them. */
export function OrderingNotConfigured({
  restaurantId,
  missing,
}: {
  restaurantId: number
  missing: Array<OrderingMissing>
}) {
  const { t } = useTranslation('purchase-orders')
  const { can } = usePermissions()
  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{t('notConfigured.title')}</AlertTitle>
      <AlertDescription>
        <p>
          {t('notConfigured.missing', {
            missing: missing.map((m) => t(`config.missing.${m}`)).join(', '),
          })}
        </p>
        {can(ACTIONS.RESTAURANT_MANAGE) && (
          <Link
            to="/restaurants/$id/purchase-ordering"
            params={{ id: String(restaurantId) }}
            className="underline"
          >
            {t('notConfigured.settings')}
          </Link>
        )}
      </AlertDescription>
    </Alert>
  )
}
